import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AccountService, AlertService } from '@app/_services';
import { AppToasterService } from '@shared/service/app-toaster.service';
import { SSOAuthService } from '@app/_services/sso.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(
        private accountService: AccountService,
        private alertService: AlertService, 
        private notify: AppToasterService,
        private ssoAuthService: SSOAuthService) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError((err) => {
            if ([401,403].includes(err.status) && this.accountService.userLoggedIn) {
                // auto logout if 401 or 403 response returned from api

                // In some cases we get 401 on logout API also, causing infinite API call loop, this condition is to avoid that
                if (!request.url.includes('account/logout')) {
                    this.accountService.logout(true);
                } else {
                    this.ssoAuthService.logout();
                }
            }
            if (err.status === 429) {
                const error = err.error;
                this.notify.error(error);
                abp.ui.clearBusy();
                return throwError(error);
            }
            
            if (err.status === 400) {
                const error = err.error?.error || err.statusText;
                
                this.notify.error(`Invalid Data`);
                abp.ui.clearBusy();
                console.error('Validation Error (400):', err);
                return throwError(error);
            }

            const error = err.error?.error || err.statusText;
            this.notify.error(error.details,error.message);
            abp.ui.clearBusy();
            console.error(err);
            return throwError(error);
        }))
    }

}